var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9847 7.08313C16.0191 7.08313 19.2897 6.01868 19.2897 4.70563C19.2897 3.39257 16.0191 2.32812 11.9847 2.32812C7.95025 2.32812 4.67969 3.39257 4.67969 4.70563C4.67969 6.01868 7.95025 7.08313 11.9847 7.08313Z",
    stroke: "#A1ABB2",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9845 5.44844C14.1322 5.44844 15.8732 4.96155 15.8732 4.36094C15.8732 3.76033 14.1322 3.27344 11.9845 3.27344C9.83676 3.27344 8.0957 3.76033 8.0957 4.36094C8.0957 4.96155 9.83676 5.44844 11.9845 5.44844Z",
    stroke: "#A1ABB2",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67969 4.70508V5.79604C4.67969 7.31127 7.94969 8.54077 11.9847 8.54077C16.0197 8.54077 19.2897 7.31127 19.2897 5.79604V4.70508",
    stroke: "#A1ABB2",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9817 17.8906C4.49037 18.2365 4.21875 18.6241 4.21875 19.0325C4.21875 20.491 7.70194 21.6746 12 21.6746C16.2981 21.6746 19.7812 20.491 19.7812 19.0325C19.7812 18.6657 19.4018 18.3199 19.0103 18.0031",
    stroke: "#A1ABB2",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5.9375V18.0614C19 19.0966 15.8065 19.9375 11.9702 19.9375C8.13403 19.9375 5 19.0966 5 18.0614V5.9375",
    stroke: "#A1ABB2",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51953 7.90039V19.3563",
    stroke: "#A1ABB2",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 8.16406V19.9358",
    stroke: "#A1ABB2",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0957 8.16406V19.9358",
    stroke: "#A1ABB2",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4531 7.90039V19.3563",
    stroke: "#A1ABB2",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco10);
export default __webpack_public_path__ + "static/media/ico-10.e129a7183cad8c4db562716d53b74c4f.svg";
export { ForwardRef as ReactComponent };